import React from 'react';
import styled from 'styled-components';
import { useSubscribeComponentChanges } from '../../hooks/component/useSubscribeComponentChanges';
import { ComponentRenderer } from '../renderers/ComponentRenderer';
import { SiteComponent } from '../SiteComponentPlugin';
import { SiteComponentStackConfigurator } from './SiteComponentStackPlugin';
const StyledContainer = styled.div `
  display: flex;
  & > *:not(:last-child) {
    margin-right: 5px;
  }
`;
export const SiteQueryFieldStack = props => {
    const component = useSubscribeComponentChanges(SiteQueryFieldStackPlugin, props);
    return (React.createElement(SiteComponent, Object.assign({ plugin: SiteQueryFieldStackPlugin }, props), component.children && component.children.length > 0 && (React.createElement(StyledContainer, null, component.children.map(child => (React.createElement("div", { key: child.id },
        React.createElement(ComponentRenderer, { component: child, componentProps: { queryValueProps: props.queryValueProps } }))))))));
};
export const SiteQueryFieldStackConfigurator = props => {
    return React.createElement(SiteComponentStackConfigurator, { component: props.component });
};
export const SiteQueryFieldStackPlugin = {
    name: 'Query Field Stack',
    type: 'site-query-field-stack',
    component: SiteQueryFieldStack,
    configurator: SiteQueryFieldStackConfigurator
};
//# sourceMappingURL=SiteQueryFieldStackPlugin.js.map